<template>
    <v-window v-model="step" style="width: 40vw">
        <v-window-item :value="1">
            <v-card
                elevation="0"
                class="px-4 my-4"
                style="background-color: white; border-radius: 25px"
            >
                <v-card-text class="text-h6 mx-auto">
                    <div v-if="isCreditNote">
                        Vous allez valider votre premier avoir. Choisissez votre règle de
                        reinitialisation du compteur de votre chrono des avoirs.
                    </div>
                    <div v-else-if="isQuote">
                        Vous allez valider votre premier devis. Choisissez votre règle de
                        reinitialisation du compteur de votre chrono des devis.
                    </div>
                    <div v-else-if="isBillOfDelivery">
                        Vous allez valider votre premier bon de livraison. Choisissez votre règle de
                        reinitialisation du compteur de votre chrono des bon de livraison.
                    </div>
                    <div v-else>
                        Vous allez valider votre première facture. Choisissez votre règle de
                        reinitialisation du compteur de votre chrono des factures.
                    </div>
                </v-card-text>
                <v-card-actions>
                    <v-radio-group v-model="data.resetChronoCondition" inline color="primary">
                        <v-tooltip location="bottom">
                            <template v-slot:activator="{ props }">
                                <v-radio label="Aucun" value="NONE" v-bind="props" />
                            </template>
                            <span>Le compteur de votre chrono ne se réinitialisera jamais.</span>
                        </v-tooltip>
                        <v-tooltip location="bottom">
                            <template v-slot:activator="{ props }">
                                <v-radio label="Mensuel" value="MONTH" v-bind="props" />
                            </template>
                            <span
                                >Le compteur de votre chrono se réinitialisera à 1 tout les
                                mois</span
                            >
                        </v-tooltip>
                        <v-tooltip location="bottom">
                            <template v-slot:activator="{ props }">
                                <v-radio label="Annuel" value="YEAR" v-bind="props" />
                            </template>
                            <span
                                >Le compteur de votre chrono se réinitialisera à 1 tout les
                                ans</span
                            >
                        </v-tooltip>
                    </v-radio-group>
                </v-card-actions>
            </v-card>
        </v-window-item>
        <v-window-item :value="2">
            <v-card
                elevation="0"
                class="px-4 my-4"
                style="background-color: white; border-radius: 25px"
            >
                <v-card-subtitle class="d-flex justify-end">
                    <v-tooltip location="bottom">
                        <template v-slot:activator="{ props }">
                            <v-icon color="secondary" v-bind="props">$oss-help</v-icon>
                        </template>
                        <span><strong>Formatage du chrono de facturation</strong><br /></span>
                        <span>Ce qui doit être présent obligatoirement: <br /></span>
                        <span>- Le compteur de factures = "X"<br /></span>
                        <span v-if="data.resetChronoCondition !== 'NONE'"
                            >- Année au format long = "YYYY"<br
                        /></span>
                        <span v-if="data.resetChronoCondition === 'MONTH'"
                            >- Mois = "MM" pour afficher le mois<br
                        /></span>
                        <span><br />Ce que vous pouvez saisir:<br /></span>
                        <span v-if="data.resetChronoCondition === 'NONE'"
                            >- Année au format long = "YYYY"<br
                        /></span>
                        <span>- Année au format court = "YY"<br /></span>
                        <span v-if="data.resetChronoCondition !== 'MONTH'"
                            >- Mois = "MM" pour afficher le mois<br
                        /></span>
                        <span>- Jour = "DD" pour afficher le jour<br /></span>
                    </v-tooltip>
                </v-card-subtitle>
                <v-card-text class="text-h6 mx-auto">
                    <div v-if="isCreditNote">
                        Veuillez spécifier la nomenclature du chrono de vos avoir.
                    </div>
                    <div v-else-if="isQuote">
                        Veuillez spécifier la nomenclature du chrono de vos devis.
                    </div>
                    <div v-else-if="isBillOfDelivery">
                        Veuillez spécifier la nomenclature du chrono de vos bon de livraison.
                    </div>
                    <div v-else>Veuillez spécifier la nomenclature du chrono de vos facture.</div>
                </v-card-text>
                <v-card-actions class="d-flex flex-column align-start">
                    <v-text-field-filled
                        label="Chrono"
                        v-model="data.chrono"
                        style="width: 100%"
                        :error="isChronoError"
                        :error-messages="chronoError"
                        :hide-details="false"
                    />
                    <p>Exemple: {{ chronoExample }}</p>
                </v-card-actions>
            </v-card>
        </v-window-item>
        <v-window-item :value="3">
            <v-card
                elevation="0"
                class="px-4 my-4"
                style="background-color: white; border-radius: 25px"
            >
                <v-card-text class="text-h6 mx-auto">
                    <div v-if="isCreditNote">
                        C'est votre premier avoir{{ timeMessage }}. A combien voulez-vous commencer
                        le compteur des avoirs.
                    </div>
                    <div v-else-if="isQuote">
                        C'est votre premier devis{{ timeMessage }}. A combien voulez-vous commencer
                        le compteur des devis.
                    </div>
                    <div v-else-if="isBillOfDelivery">
                        C'est votre premier bon de livraison{{ timeMessage }}. A combien voulez-vous
                        commencer le compteur des bon de livraison.
                    </div>
                    <div v-else>
                        C'est votre première facture{{ timeMessage }}. A combien voulez-vous
                        commencer le compteur des factures.
                    </div>
                </v-card-text>
                <v-card-actions class="d-flex flex-column align-start">
                    <v-text-field-filled
                        label="compteur"
                        type="number"
                        v-model="data.counter"
                        style="width: 100%"
                    />
                    <p>Exemple: {{ chronoExample }}</p>
                </v-card-actions>
            </v-card>
        </v-window-item>
        <v-window-item :value="4">
            <v-card
                elevation="0"
                class="px-4 my-4"
                style="background-color: white; border-radius: 25px"
            >
                <v-card-text class="text-h6 mx-auto">
                    <div v-if="isRecurent">
                        Voulez-vous vraiment valider cette facture réccurente ? Cette action ne
                        pourra pas être annulée
                    </div>
                    <div v-else-if="isInvoiceMatrix">
                        Voulez-vous vraiment valider toutes les fatures? Cette action ne pourra pas
                        être annulée
                    </div>
                    <div v-else-if="isCreditNote">
                        Voulez-vous vraiment valider cet avoir ? Cette action ne pourra pas être
                        annulée
                    </div>
                    <div v-else-if="isQuote">
                        Voulez-vous vraiment valider ce devis ? Cette action ne pourra pas être
                        annulée
                    </div>
                    <div v-else-if="isBillOfDelivery">
                        Voulez-vous vraiment valider ce bon de livraison ? Cette action ne pourra
                        pas être annulée
                    </div>
                    <div v-else>
                        Voulez-vous vraiment valider cette facture ? Cette action ne pourra pas être
                        annulée
                    </div>
                </v-card-text>
            </v-card>
        </v-window-item>
    </v-window>
</template>

<script lang="ts">
import { confirmInvoice } from "@/types/confirmInvoice.types";

import moment from "moment-timezone";
import { Component, Vue, toNative } from "vue-facing-decorator";
import { Prop } from "vue-facing-decorator";

@Component
export class InvoiceConfirmInvoice extends Vue {
    @Prop({ default: 3 }) step: number;
    @Prop({ default: "INVOICE" }) type: string;
    @Prop({ default: {} }) data: confirmInvoice;
    @Prop({ default: {} }) otherChrono;

    get timeMessage() {
        switch (this.data.resetChronoCondition) {
            case "NONE":
                return "";
            case "MONTH":
                return " ce mois-ci";
            case "YEAR":
                return " cette année";
        }
    }

    get isRecurent() {
        if (this.type === "INVOICE_RECURRENT") {
            return true;
        }
        return false;
    }

    get isInvoiceMatrix() {
        if (this.type === "INVOICE_MATRIX") {
            return true;
        }
        return false;
    }

    get isCreditNote() {
        if (this.type === "CREDIT_NOTE") {
            return true;
        }
        return false;
    }

    get isQuote() {
        if (this.type === "QUOTATION") {
            return true;
        }
        return false;
    }

    get isBillOfDelivery() {
        if (this.type === "BILL_DELIVERY") {
            return true;
        }
        return false;
    }

    get isDeposit() {
        if (this.type === "DEPOSIT") {
            return true;
        }
        return false;
    }

    get isInvoice() {
        if (this.type === "INVOICE") {
            return true;
        }
        return false;
    }

    get isChronoError() {
        console.log(this.otherChrono);
        let regex = /(?=.*X).+/;
        switch (this.data.resetChronoCondition) {
            case "MONTH":
                regex = /(?=.*YYYY)(?=.*X)(?=.*MM).+/;
                break;
            case "YEAR":
                regex = /(?=.*YYYY)(?=.*X).+/;
                break;
        }
        const match = regex.test(this.data.chrono);
        if (!match) {
            this.data.isError = true;
            return true;
        }
        if (!this.isQuote && this.data.chrono === this.otherChrono.quoteChrono) {
            this.data.isError = true;
            return true;
        } else if (!this.isCreditNote && this.data.chrono === this.otherChrono.creditNoteChrono) {
            this.data.isError = true;
            return true;
        } else if (
            !this.isBillOfDelivery &&
            this.data.chrono === this.otherChrono.deliveryBillChrono
        ) {
            this.data.isError = true;
            return true;
        } else if (!this.isDeposit && this.data.chrono === this.otherChrono.depositChrono) {
            this.data.isError = true;
            return true;
        } else if (
            !this.isInvoice &&
            !this.isRecurent &&
            this.data.chrono === this.otherChrono.invoiceChrono
        ) {
            this.data.isError = true;
            return true;
        }
        this.data.isError = false;
        return false;
    }

    get chronoError() {
        let typeName = "";
        let pronoun = "de ";

        switch (this.type) {
            case "INVOICE_RECURRENT":
            case "INVOICE":
                typeName = "factures";
                break;
            case "DEPOSIT":
                typeName = "acomptes";
                pronoun = "d'";
                break;
            case "QUOTE":
                typeName = "devis";
                break;
            case "CREDIT_NOTE":
                typeName = "avoirs";
                pronoun = "d'";
                break;
            case "BILL_DELIVERY":
                typeName = "bon de livraisons";
                break;
        }
        let regex = /(?=.*X).+/;
        let matchError = "Vous devez renseigner obligatoirement le compteur " + pronoun + typeName;
        switch (this.data.resetChronoCondition) {
            case "MONTH":
                regex = /(?=.*YYYY)(?=.*X)(?=.*MM).+/;
                matchError =
                    "Vous devez renseigner obligatoirement le compteur " +
                    pronoun +
                    typeName +
                    ', l\'année au format long "YYYY" et le mois au format "MM"';
                break;
            case "YEAR":
                regex = /(?=.*YYYY)(?=.*X).+/;
                matchError =
                    "Vous devez renseigner obligatoirement le compteur " +
                    pronoun +
                    typeName +
                    ' et l\'année au format long "YYYY"';
                break;
        }
        const match = regex.test(this.data.chrono);
        if (!match) {
            return matchError;
        }
        if (!this.isQuote && this.data.chrono === this.otherChrono.quoteChrono) {
            return "Le chrono des " + typeName + " et celui des devis doivent être différent";
        } else if (!this.isCreditNote && this.data.chrono === this.otherChrono.creditNoteChrono) {
            return "Le chrono des " + typeName + " et celui des avoirs doivent être différent";
        } else if (
            !this.isBillOfDelivery &&
            this.data.chrono === this.otherChrono.deliveryBillChrono
        ) {
            return (
                "Le chrono des " +
                typeName +
                " et celui des bon de livraison doivent être différent"
            );
        } else if (!this.isDeposit && this.data.chrono === this.otherChrono.depositChrono) {
            return "Le chrono des " + typeName + " et celui des acomptes doivent être différent";
        } else if (
            !this.isInvoice &&
            !this.isRecurent &&
            this.data.chrono === this.otherChrono.invoiceChrono
        ) {
            return "Le chrono des " + typeName + " et celui des factures doivent être différent";
        }
        return "";
    }

    get chronoExample() {
        if (this.isChronoError) {
            return "";
        }
        const date = moment(new Date());
        const mounth = date.format("MM");
        const fullYear = date.format("YYYY");
        const year = date.format("YY");
        const day = date.format("DD");
        const regex: RegExp = /(X+)/;
        const match = this.data.chrono.match(regex);
        const counter = this.data.counter;
        let numberZero;

        if (match.length) {
            numberZero = match.at(0).length;
        }

        let chrono = this.data.chrono;

        chrono = chrono.replaceAll("YYYY", fullYear);
        chrono = chrono.replaceAll("YY", year);
        chrono = chrono.replaceAll("MM", mounth);
        chrono = chrono.replaceAll("DD", day);
        chrono = chrono.replaceAll(match.at(0), counter.toString(10).padStart(numberZero, "0"));
        return chrono;
    }
}

export default toNative(InvoiceConfirmInvoice);
</script>
